import { FileReference } from "./baseEntities";

export interface Product {
  name: string;
  descr: string;
  code: string;
  sku: string;
  price: number;
  taxCodes: string[];
  hideFromCartAndKitchen: boolean;
  image: FileReference | null;
  minChildren: number | null;
  maxChildren: number | null;
  children: ProductChild[];
  soldOut: boolean;
}

export interface ProductChild {
  minQty: number | null;
  defaultQty: number | null;
  maxQty: number | null;
  visibilityRule: ChildVisibilityRule | null;
  productCode: string;
  product: Product;
}

export enum ChildVisibilityRule {
  NOT_ZERO = "NOT_ZERO", // (default) show line unless qty would be 0
  ALWAYS = "ALWAYS", // show line even when qty is 0
  NOT_DEFAULT = "NOT_DEFAULT", // hide line when qty is default + no children + price is free
}
